import { call, put, takeEvery } from "redux-saga/effects";
import { admin } from "../types";
import lambdas from "../lambdas/apis"


export function* resetadminsStore(action) {
    yield put({ type: admin.RESET_ADMIN_STORE_SUCCESS, payload: {} })
}

export function* listAllCity(action) {
    const { dropdown = false, userterritories = false, limit, offset, role } = action.payload
    try {
        const response = yield call(lambdas.locations.cities.listAllCity, {}, {}, { limit, offset, userterritories, role });
        if (response.data.code === 200) {
            let cityList = response.data.data;
            if (dropdown) {
                cityList = []
                response.data.data.map(item => {
                    return cityList.push({
                        key: `cities_${item.city_id}`,
                        value: item.city_id,
                        text: item.city_name,
                        city: item
                    })
                })
            }
            yield put({ type: admin.LIST_ALL_CITY_SUCCESS, payload: cityList })
        }
        else {
            yield put({ type: admin.LIST_ALL_CITY_FAILURE, payload: { message: 'Oops Something went wrong' } })
        }
    } catch (error) {
        yield put({ type: admin.LIST_ALL_CITY_FAILURE, payload: error })
    }
}



export default function* adminSaga() {
    yield takeEvery(admin.RESET_ADMIN_STORE_REQUEST, resetadminsStore)
    yield takeEvery(admin.LIST_ALL_CITY_REQUEST, listAllCity)
}